<ion-card>
  <ion-card-header>
    <ion-card-title>Iktatókönyv</ion-card-title>
    <ion-card-subtitle>
      Az ügyiratok (főszámok) listája. Egy sorra kattintva látszik az ügy összes irata,
      a határidők és a teljes eseménynapló.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-select label="Iktatókönyv" label-placement="stacked" interface="popover"
                  [(ngModel)]="szuro.konyv" (ionChange)="betolt()">
        <ion-select-option value="">mind</ion-select-option>
        <ion-select-option *ngFor="let k of konyvek" [value]="k.id">{{ k.nev }} ({{ k.jel }})</ion-select-option>
      </ion-select>
      <ion-input label="Év" label-placement="stacked" type="number" [(ngModel)]="szuro.ev"
                 (ionBlur)="betolt()"></ion-input>
      <ion-select label="Állapot" label-placement="stacked" interface="popover"
                  [(ngModel)]="szuro.allapot" (ionChange)="betolt()">
        <ion-select-option value="">mind</ion-select-option>
        <ion-select-option value="folyamatban">folyamatban</ion-select-option>
        <ion-select-option value="elintezve">elintézve</ion-select-option>
        <ion-select-option value="irattarban">irattárban</ion-select-option>
        <ion-select-option value="selejtezve">selejtezve</ion-select-option>
        <ion-select-option value="leveltarban">levéltárban</ion-select-option>
      </ion-select>
      <ion-searchbar placeholder="Tárgy vagy iktatószám…" [(ngModel)]="szuro.kereses"
                     [debounce]="300" (ionChange)="betolt()"></ion-searchbar>
    </div>

    <ion-note color="medium" *ngIf="hozzaferes && !hozzaferes.mindent_lat" style="display:block;margin-bottom:8px">
      Csak a hozzád rendelt ügyiratokat látod.
    </ion-note>

    <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <div class="ikt-tabla-doboz" *ngIf="!betoltes">
      <table class="ikt-tabla">
        <thead>
          <tr>
            <th>Iktatószám</th><th>Tárgy</th><th>Ügyintéző</th><th class="szam">Határidő</th>
            <th class="szam">Iratok</th><th>Állapot</th><th>Tétel</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of sorok" (click)="nyit(u)" style="cursor:pointer"
              [class.ervenytelen]="u.ervenytelen">
            <td class="iktszam">{{ u.iktatoszam }}</td>
            <td>{{ u.targy }}</td>
            <td>{{ u.ugyintezo }}</td>
            <td class="szam">
              {{ u.hatarido }}
              <ion-badge color="danger" *ngIf="lejart(u)">lejárt</ion-badge>
            </td>
            <td class="szam">{{ u.irat_db }}</td>
            <td><ion-badge [color]="allapotSzin(u.allapot)">{{ u.allapot }}</ion-badge></td>
            <td>{{ u.tetelszam }}</td>
          </tr>
        </tbody>
      </table>
      <div class="ikt-ures" *ngIf="!sorok.length">Nincs a szűrésnek megfelelő ügyirat.</div>
    </div>
  </ion-card-content>
</ion-card>
